
const dev = {
  type: 'dev',
}
const prod = {
  type: 'prod'
}

const env_config = {
  dev,
  prod
}

const envs = (name = 'prod') => {
  return env_config[name] || dev;
}

export const env = envs();